import { render } from "./Otto.vue?vue&type=template&id=0a9970af&ts=true"
import script from "./Otto.vue?vue&type=script&lang=ts"
export * from "./Otto.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__